import LoadingPlaceholder from "../components/loadingPlaceholder";
import { useFetch } from "../hooks";
import { Markup } from "react-render-markup";
import FetchError from "../components/fetchError";

function PrivacyPolicy() {
  const { response, loading, error, retry } = useFetch("store/privacy-policy");

  if (error)
    return (
      <FetchError
        message="Nie udało się wczytać polityki prywatności."
        onRetry={retry}
      />
    );

  if (loading || !response) return <LoadingPlaceholder />;

  return (
    <main className="content-page regulations-page">
      <article className="content-page__paper">
        <Markup markup={response.body} />
      </article>
    </main>
  );
}

export default PrivacyPolicy;
